// @flow
import { TimelineLite } from 'gsap'

export default class DetailAnimation {
  setOpacity: (opacity: number) => void
  appear: TimelineLite
  elementsAttributes: {
    opacity: number
  }
  duration: number
  canReverse: boolean
  
  constructor(elementsOpacity: number, setOpacity: (opacity: number) => void) {
    this.setOpacity = setOpacity
    this.appear = new TimelineLite({ paused: true })
    this.elementsAttributes = { opacity: elementsOpacity }
    this.duration = 1
    this.canReverse = true
    this.initAppear()
  }

  onComplete () {
    if (this.canReverse) this.appear.reverse()
  }

  initAppear() {
    this.appear.to(
      this.elementsAttributes,
      this.duration,
      {
        opacity: 1,
        onComplete: () => {
          this.onComplete()
        },
        onUpdate: () => {
          this.setOpacity(this.elementsAttributes.opacity)
        }
      }
    )
  }

  startAppear() {
    if (this.appear.progress() !== 1) {
      this.appear.play(this.elementsAttributes.opacity)
      return true
    }
    return false
  }

  destroy() {
    this.appear.paused(true)
    this.appear.kill()
  }

  firstPlay(): Promise<void> {
    return new Promise((resolve: () => void) => {
      setTimeout(() => {
        this.startAppear()
        resolve()
      }, 700); // @WARNING --> value must be the same as in css
    })
  }

  pauseAppear () {
    this.canReverse = false
    if (!this.startAppear()) this.appear.paused(true)
  }

  unpauseAppear () {
    this.canReverse = true
    this.appear.reverse()
  }
}


// WEBPACK FOOTER //
// ./src/utils/detailAnimationsUtils.js